// Styles.
import { FormStyles } from "../styles/features/FormStyles";

interface FormProps {
  children: React.ReactNode;
  className?: string;
}

const Form: React.FC<FormProps> = ({ children, className }) => {
  return <FormStyles className={className}>{children}</FormStyles>;
};

export default Form;
